import { render, staticRenderFns } from "./TiposControleFinanceiro.vue?vue&type=template&id=e767340e&"
import script from "./TiposControleFinanceiro.vue?vue&type=script&lang=ts&"
export * from "./TiposControleFinanceiro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports